module.exports = __webpack_public_path__ + "img/img9.4e85fd20.jpg";